<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <div class="overtime-record-tab">
        <v-tabs
          v-model="activeInnerTab"
          background-color="grey lighten-3"
          class="elevation-0"
          color="blue"
        >
          <v-tab class="px-6">
            <v-icon size="20" class="mr-2">mdi-calendar-clock</v-icon>
            補休總覽
          </v-tab>
          <v-tab class="px-6">
            <v-icon size="20" class="mr-2">mdi-timer-outline</v-icon>
            加班紀錄
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeInnerTab" class="bg-white">
          <v-tab-item>
            <compensatory-leaves-widget
              ref="compensatoryLeavesWidget"
              :selected-company="selectedCompany"
              @error="forwardError"
            />
          </v-tab-item>
          <v-tab-item>
            <overtime-records-widget
              ref="overtimeRecordsWidget"
              :selected-company="selectedCompany"
              @error="forwardError"
            />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import OvertimeRecordsWidget from "@/components/Widgets/OvertimeRecordsWidget.vue";
import CompensatoryLeavesWidget from "@/components/Widgets/CompensatoryLeavesWidget.vue";

export default {
  name: "OvertimeRecordTab",
  components: {
    OvertimeRecordsWidget,
    CompensatoryLeavesWidget,
  },
  props: {
    selectedCompany: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      activeInnerTab: 0,
    };
  },
  watch: {
    activeInnerTab(newVal) {
      this.$nextTick(() => {
        if (newVal === 0) {
          this.$refs.overtimeRecordsWidget?.fetchOvertimeRecords?.();
        } else if (newVal === 1) {
          this.$refs.compensatoryLeavesWidget?.fetchCompensatoryLeaves?.();
        }
      });
    },
  },
  methods: {
    forwardError(event) {
      this.$emit("error", event);
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.overtimeRecordsWidget?.fetchOvertimeRecords?.();
        this.$refs.compensatoryLeavesWidget?.fetchCompensatoryLeaves?.();
      });
    },
  },
};
</script>

<style scoped>
.overtime-record-tab {
  min-height: 400px;
}
.v-tab--active {
  font-weight: bold !important;
  font-size: 1.05rem;
}
</style>
